import { Link } from 'react-router-dom';

import { Panel } from '../components/ui/Panel';
import { useAccount } from '../hooks/useAccount';
import { useDocumentHead } from '../hooks/useDocumentHead';

/**
 * Landing after Stripe Checkout. Payment may confirm before the webhook has
 * written the plan, so we never claim the upgrade is already live here.
 */
export function CheckoutSuccessPage() {
    useDocumentHead({
        title: 'Checkout complete · ActualSold',
        description: 'Payment received. Check your email for the sign-in link.',
        canonicalPath: '/checkout/success',
        noindex: true,
    });

    const account = useAccount();

    return (
        <div className="mx-auto max-w-lg space-y-6 pb-8">
            <header className="space-y-2">
                <p className="eyebrow text-text-muted">Checkout</p>
                <h1 className="text-title">Payment received</h1>
            </header>

            <Panel title="What happens next">
                <ol className="list-decimal space-y-3 pl-5 text-sm text-text-muted">
                    <li>
                        Stripe confirms the subscription. That may take a few seconds after this
                        page loads.
                    </li>
                    <li>
                        If this is a new account, check your email for a one-time sign-in link.
                        That is how you reach the console the first time.
                    </li>
                    <li>
                        If you already had a free account with the same email, sign in as usual.
                        Your plan updates when the webhook lands.
                    </li>
                </ol>
            </Panel>

            <div className="flex flex-wrap gap-3">
                {account.data ? (
                    <Link
                        to="/app"
                        className="inline-flex items-center justify-center rounded-md border border-primary bg-primary px-4 py-2.5 text-sm font-medium text-text-on-primary hover:border-primary-hover hover:bg-primary-hover"
                    >
                        Open console
                    </Link>
                ) : (
                    <Link
                        to="/signin"
                        className="inline-flex items-center justify-center rounded-md border border-primary bg-primary px-4 py-2.5 text-sm font-medium text-text-on-primary hover:border-primary-hover hover:bg-primary-hover"
                    >
                        Sign in
                    </Link>
                )}
                <Link
                    to="/docs"
                    className="inline-flex items-center justify-center rounded-md border border-border-strong bg-surface px-4 py-2.5 text-sm font-medium text-text hover:border-secondary"
                >
                    API docs
                </Link>
            </div>
        </div>
    );
}
